import { IBrickInstanceTargetingAction } from '../../utility/IBrickInstanceTargetingAction';
import { LongRunningContextCategoryTyp } from '../../../samwebDescription/samweb/waitingContext/waitingContextCategory';

export class LongRunningContextStarted implements IBrickInstanceTargetingAction {
   public static readonly type = '[LongRunningContext] long running context started';

   constructor(public waitingContextCategory: LongRunningContextCategoryTyp, public brickInstanceId: string = null) {}
}

export class LongRunningContextStopped implements IBrickInstanceTargetingAction {
   public static readonly type = '[LongRunningContext] long running context stopped';

   constructor(public waitingContextCategory: LongRunningContextCategoryTyp, public brickInstanceId: string = null) {}
}
